<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} vé điện tử</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} vé điện tử</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} vé điện tử</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="3">
              <el-form-item label="Tên" prop="ten">
                <el-input
                  v-model="mData.dataForm.ten"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="5">
              <el-form-item label="Website" prop="url">
                <el-input
                  v-model="mData.dataForm.url"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Loại hình" prop="loai_hinh">
                <el-select
                  v-model="mData.dataForm.loai_hinh"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'update'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listLoaiHinh"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="2" v-if="mData.ifHavePermission">
              <el-form-item label="Trạng thái" prop="duyet.duoc_duyet">
                <el-select
                  v-model="mData.dataForm.duyet.duoc_duyet"
                  disabled
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listAccept"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item class="mb-3" label="Ảnh đại diện" prop="mediaId">
                <el-upload
                  action
                  :auto-upload="false"
                  list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit"
                  :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien"
                  :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien"
                  :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                  :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog
                  :close-on-click-modal="true"
                  :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%"
                  top="51px"
                  title="Chi tiết"
                >
                  <img
                    width="100%"
                    :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl"
                    alt
                  />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import MethodService from '../../../service/MethodService';
import VeDienTuModel from './VeDienTuModel';
import VeDienTuApi from '../../../moduleApi/VeDienTuApi';
import InfoVeDienTuApi from '@/moduleApi/InfoVeDienTuApi';
import ExtensionService from "../../../service/ExtensionService";
export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "VeMayBay",
        dataDefault: {
            listLoaiHinh: [
            {
              value: 0,
              label: 'Vé máy bay'
            },
            {
              value: 1,
              label: 'Vé nghệ thuật biểu diễn'
            }
          ],
          listAccept:[
            {
              value: 0,
              label: 'Đã duyệt'
            },
            {
              value: 1,
              label: 'Chờ duyệt'
            },
            {
              value: 2,
              label: 'Từ chối'
            }
          ]
        },
        dataForm: MethodService.copyObject(VeDienTuModel.dataForm),
        dataFormOther: MethodService.copyObject(VeDienTuModel.dataFormOther),
        fileUploadOption: MethodService.copyObject(
          VeDienTuModel.dataFormOther.fileUploadOption
        ),
        validForm: VeDienTuModel.validForm,
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        ifHavePermission: false,
      },
    };
  },
  async created() {

    if (this.mData.currentUser.id) {
      let dataFilter = {
        filters: 'nguoi_tao_id='+this.mData.currentUser.id
      };
      let resInfoVeDienTu = await InfoVeDienTuApi.list(dataFilter);
      this.mData.dataFormOther.id = resInfoVeDienTu.result[0].id;
      await this.fn_getDataById(this.mData.dataFormOther.id);
      if (
      !this.mData.dataForm.id
        ) {
      this.mData.viewMode = "create";
     } else{
        this.mData.ifHavePermission = true;
        this.mData.viewMode = "update";
        }
    }
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "create") {
            data.id = this.mData.currentUser.id;
            await VeDienTuApi.create(data);
            this.fn_resetForm();
            this.$router.push({ name: "Admin-ThongTinDDAT-detail"});
          }
          if (type === "update") {
            data.id = this.mData.currentUser.id;
            await VeDienTuApi.update(data);
            this.$router.push({ name: "Admin-ThongTinDDAT-detail"});
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        VeDienTuModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      let ve_may_bay = await VeDienTuApi.findById(id);
      let resForm = {};
      if (ve_may_bay.result) {
        this.mData.dataForm = ve_may_bay.result;
        if (ve_may_bay.result.mediaId) {
          let data = {
            id: ve_may_bay.result.mediaId,
            name: ve_may_bay.result.mediaId,
            url: ExtensionService.urlImg + ve_may_bay.result.mediaId
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
        resForm.id = this.mData.dataForm.id;
      }else{
        this.$confirm(
            "Bạn chưa khai báo đầy đủ thông tin Đơn vị cung cấp, vui lòng khai báo trước khi truy cập tính năng này!",
            {
              confirmButtonText: LanguageService.lang.c_agree,
              showClose: false,
              showCancelButton: false,
              type: "warning",
            }
          )
            .then(() => {
              this.$router.push({
                name: "Admin-VeDienTuForm-create",
                params: { id: resForm.id },
              });
            })
      }
    },
    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.mediaId = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField('mediaId');
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "diemDen")
        .then(res => {
          this.mData.dataForm.mediaId = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField('mediaId');
        })
        .catch(() => {
          this.$refs["myForm"].validateField('mediaId');
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },

    fn_go() {
      this.$router.go(-1);
    }
  }
}
</script>
